module.exports = __webpack_public_path__ + "static/infogramas1-121f6ce38779b89a1f21ce7e5c02e0ab.png";